<template>
  <div>
    <v-card
      outlined>
      <v-card-title :bind="title" class="light-blue--text justify-space-between">
        <h3 class="headline" v-text="title"></h3>
        <v-btn aria-label="Delete This Property" small v-if="!$props.isNew" @click="deleteDialog = true" icon color="grey">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-card-title>
      <div class="px-4 pb-4">
        <transition name="fade-transition" mode="out-in">
          <v-img v-if="propertyData.photoUrl" :src="propertyData.photoUrl">
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular indeterminate color="light-blue lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </transition>
        <v-form
          ref="form"
          v-model="formValid"
        >
          <v-row>
            <v-col cols="12" class="pb-0">
              <div class="font-weight-bold text-uppercase mb-1">Property Address</div>
              <v-text-field class="rounded-0"
                            label="Address"
                            dense
                            :rules="notEmptyRules"
                            color="light-blue"
                            v-model="propertyData.addressLineOne"
                            filled
                            outlined
              ></v-text-field>
            </v-col>
            <v-col class="py-0" cols="12" md="6">
              <v-text-field class="rounded-0"
                            label="City"
                            dense
                            :rules="notEmptyRules"
                            color="light-blue"
                            v-model="propertyData.city"
                            filled
                            outlined
              ></v-text-field>
            </v-col>
            <v-col class="py-0" cols="12" md="3">
              <v-text-field class="rounded-0"
                            label="State"
                            dense
                            :rules="notEmptyRules"
                            color="light-blue"
                            v-model="propertyData.state"
                            filled
                            outlined
              ></v-text-field>
            </v-col>
            <v-col class="py-0" cols="12" md="2" lg="3" xl="2">
              <v-text-field class="rounded-0"
                            label="Zip"
                            dense
                            :rules="notEmptyRules"
                            color="light-blue"
                            v-model="propertyData.zip"
                            filled
                            outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pb-0">
              <div class="font-weight-bold text-uppercase mb-1">Tenant Name</div>
              <v-row>
                <v-col class="py-0" cols="12" md="6">
                  <v-text-field class="rounded-0"
                                label="First Name"
                                dense
                                :rules="notEmptyRules"
                                color="light-blue"
                                v-model="propertyData.tenantFirstName"
                                filled
                                outlined
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" md="6">
                  <v-text-field class="rounded-0"
                                label="Last Name"
                                dense
                                :rules="notEmptyRules"
                                color="light-blue"
                                v-model="propertyData.tenantLastName"
                                filled
                                outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <div class="font-weight-bold text-uppercase mb-1">Tenant Phone</div>
              <v-text-field class="rounded-0"
                            label="Phone"
                            dense
                            color="light-blue"
                            v-model="propertyData.tenantPhone"
                            filled
                            outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <div class="font-weight-bold text-uppercase mb-1">Tenant Cell</div>
              <v-text-field class="rounded-0"
                            label="Cell"
                            dense
                            color="light-blue"
                            v-model="propertyData.tenantCellPhone"
                            filled
                            outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="7">
              <div class="font-weight-bold text-uppercase mb-1">Tenant Email</div>
              <v-text-field class="rounded-0"
                            label="Email"
                            type="email"
                            color="light-blue"
                            v-model="propertyData.tenantEmail"
                            dense
                            filled
                            outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5" class="pb-0">
              <v-dialog
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="propertyData.startDate"
                persistent
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div class="font-weight-bold text-uppercase mb-1">First Month</div>
                  <v-text-field class="rounded-0"
                                v-model="propertyData.startDate"
                                color="light-blue"
                                filled
                                dense
                                outlined
                                readonly
                                label="Start Month"
                                v-bind="attrs"
                                v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  header-color="light-blue"
                  color="light-blue"
                  type="month"
                  v-model="propertyData.startDate"
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn elevation="0" @click="menu = false">Cancel</v-btn>
                  <v-btn elevation="0" dark color="light-blue" @click="$refs.menu.save(propertyData.startDate)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>

          </v-row>
          <v-row justify="end">
            <v-col cols="12" :sm="4" :md="5" :xl="4">
              <v-btn
                :disabled="!formValid"

                block
                @click="saveProperty()"
                :dark="formValid"
                small
                color="light-blue"
                elevation="0"
                tile
              >
                {{$props.isNew ? 'Save' : 'Update'}} Property
              </v-btn>
            </v-col>
          </v-row>
        </v-form>

      </div>

    </v-card>

    <v-dialog
      v-model="deleteDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">Delete This Property?</v-card-title>

        <v-card-text>
          If you delete this property, all data associated with it will be removed. This cannot be undone.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey darken-1"
            text
            @click="deleteDialog = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="red darken-1"
            text
            @click="confirmDelete"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    name: 'ManageProperty',

    data: () => ({
      formValid: false,
      loading: true,
      menu: false,

      propertyData: {
        addressLineOne: '',
        startDate: new Date().toISOString().substr(0, 7),
        city: '',
        state: '',
        zip: '',
        photoUrl: '',
        tenantFirstName: '',
        tenantLastName: '',
        tenantPhone: '',
        tenantCellPhone: '',
        tenantEmail: '',
      },
      deleteDialog: false,
      notEmptyRules: [
        v => !!v || 'This Field is Required',
      ],

    }),
    props: {
      id: {
        type: String,
        default: null
      },
      isNew: {
        type: Boolean
      }
    },
    methods: {
      initialize() {
        if (this.propertyID) {
          this.propertyData = this.property;
        } else {
          this.resetPropertyData();
        }
      },
      async confirmDelete() {
        await this.deleteProperty(this.propertyID);
        this.deleteDialog = false;
      },
      async saveProperty() {
        if (!this.isNew && this.propertyID) {
          await this.updateProperty(this.propertyData);
        } else {
          try {
            await this.addNewProperty(this.propertyData);
            await this.$router.push('/properties/detail/' + this.propertyID);
          } catch (e) {
            console.log(e)
          }
        }
      },
      resetPropertyData() {
        this.propertyData = {
          addressLineOne: '',
          city: '',
          state: '',
          zip: '',
          photoUrl: '',
          startDate: new Date().toISOString().substr(0, 7),
          tenantFirstName: '',
          tenantLastName: '',
          tenantPhone: '',
          tenantCellPhone: '',
          tenantEmail: '',
        }
      },
      ...mapActions([
        'addNewProperty',
        'updateProperty',
        'deleteProperty'
      ]),

    },
    watch: {
      '$route.params.id': function () {
        this.initialize();
      },
      '$route.path': function () {
        this.initialize();
      },
    },

    computed: {
      title() {
        let title = (this.$props.isNew === true) ? 'Add New' : 'Edit';
        return title + ' Property';
      },
      ...mapGetters([
        'propertyAddressLineOne',
        'propertyCity',
        'propertyState',
        'propertyZip',
        'propertyTenantPhone',
        'propertyTenantCellPhone',
        'propertyTenantFullName',
        'propertyTenantEmail',
        'propertyID',
        'property',
      ]),

    },
    created() {
      this.initialize();
    },
  }
</script>

<style lang="scss" scoped>

</style>